import { Link } from "react-router-dom";
import { Logo, COLLECTIONS_NAV } from "@/components/Brand";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="steel-texture text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Logo light />
          <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
            Premium heating controls and spares for homeowners and installers across the UK.
          </p>
          <div className="mt-5 space-y-2 text-sm text-white/70">
            <a href="tel:07443173458" className="flex items-center gap-2 hover:text-accent"><Phone className="w-4 h-4" /> 07443 173458</a>
            <a href="mailto:enquiries@hhcv.co.uk" className="flex items-center gap-2 hover:text-accent"><Mail className="w-4 h-4" /> enquiries@hhcv.co.uk</a>
            <span className="flex items-center gap-2"><MapPin className="w-4 h-4 shrink-0" /> Rear Heron Drive, Darlington, Co. Durham, DL1 1DL</span>
          </div>
        </div>

        <div>
          <h4 className="text-overline text-accent mb-4">Shop</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            {COLLECTIONS_NAV.map((c) => (
              <li key={c.slug}><Link to={`/collections/${c.slug}`} className="hover:text-white transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-overline text-accent mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/guides" className="hover:text-white">Heating Guides</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/delivery-returns" className="hover:text-white">Delivery &amp; Returns</Link></li>
            <li><Link to="/faqs" className="hover:text-white">FAQs</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-overline text-accent mb-4">Legal</h4>
          <ul className="space-y-2.5 text-sm text-white/70">
            <li><Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link></li>
            <li><Link to="/product-images-disclaimer" className="hover:text-white">Product Images Disclaimer</Link></li>
            <li><Link to="/account" className="hover:text-white">My Account</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Hydronic Heating Controls &amp; Valves. All rights reserved.</span>
          <span className="tracking-wide">Secure checkout · Receipt with every order · Free UK tracked delivery (Royal Mail Tracked 48)</span>
        </div>
      </div>
    </footer>
  );
}
